<ycn-modal-base
        [open]="modalOpen"
        [requiresAction]="true"
        (closeModalHandler)="closeModal()">
    <ycn-simple-modal-header
            [header]="MODAL_HEADER_TEXT"
            [resetModalText]="RESTORE_DEFAULTS_BUTTON_TEXT"
            (closeModalHandler)="closeModal()"
            (resetModalHandler)="restoreDefaults()">
    </ycn-simple-modal-header>
    <div class="modal-body">
        <div class="modal-section">
            <div class="form-row">
                <p> {{ instructionText }}</p>
            </div>
            <div *ngIf="showSortable" class="form-row" id="data-container" #dataContainer>
                <div class="plates plates-view-list" *ngFor="let column of orderedColumns; index as i">
                    <div class="plate-container">
                        <div class="plate plate-header" [ngClass]="{'plate-purple': !numVisibleColumns || numVisibleColumns && i < numVisibleColumns}">
                            <div class="plate-title">
                                <div class="plate-title-name">
                                    <span class="d-inline-block width-40">{{ i + 1 }}.</span>{{ column.metricDisplayValue }}
                                </div>
                            </div>
                            <div class="plate-controls">
                                <div class="btn btn-xs btn-circle btn-transparent btn-lightgray btn-reorder-up plate-control"
                                     ycnTooltip
                                     [tooltipTitle]="'Reorder'"
                                     [tooltipPlacement]="'top'">
                                    <svg ycnIcon [name]="'icon-reorder-up'"></svg>
                                </div>
                                <div class="btn btn-xs btn-circle btn-transparent btn-lightgray plate-control"
                                     (click)="removeColumn(i)"
                                     ycnTooltip
                                     [tooltipTitle]="'Remove'"
                                     [tooltipPlacement]="'top'">
                                    <svg ycnIcon [name]="'icon-close'"></svg>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="d-flex mb-1">
                <ng-container *ngIf="allowInfoColumns">
                    <div class="btn btn-text" (click)="singleInfoFieldSelectorModal.openModal()">
                        <svg ycnIcon [name]="'icon-add'"></svg>
                        <span>Add Info Column</span>
                    </div>
                <div class="divider-vertical"></div>
                </ng-container>
                <div class="btn btn-text" (click)="singleMetricSelectorModal.openModal()">
                    <svg ycnIcon [name]="'icon-add'"></svg>
                    <span>Add Metric</span>
                </div>
                <div class="divider-vertical"></div>
                <div class="btn btn-text" (click)="metricSetSelectorModal.openModal()">
                    <svg ycnIcon [name]="'icon-open'"></svg>
                    <span>Open Metric Set</span>
                </div>
            </div>
            <div class="mb-2">
                <div class="feedback feedback-invalid" *ngIf="errors.length !== 0">
                    <div *ngFor="let error of errors" [textContent]="error"></div>
                </div>
            </div>
            <div class="divider-horizontal"></div>
        </div>
    </div>
    <ycn-simple-modal-footer
            [cancelButtonText]="'Cancel'"
            [submitButtonText]="submitButtonText"
            (cancelHandler)="closeModal()"
            (submitHandler)="submit()">
    </ycn-simple-modal-footer>
</ycn-modal-base>

<ycn-single-info-field-selector-modal #singleInfoFieldSelectorModal
    [infoType]="infoType"
    (selectInfoFieldHandler)="addInfoColumn($event)">
</ycn-single-info-field-selector-modal>

<ycn-single-metric-selector-modal #singleMetricSelectorModal
    [searchType]="metricSearchType"
    (submitModalHandler)="displayAndHandleModalObject($event, false)"
    (submitModalAutocompleteHandler)="displayAndHandleModalObject($event, true)">
</ycn-single-metric-selector-modal>

<ycn-open-item-modal #metricSetSelectorModal
        [items]="metricSets"
        [savedItemType]="SAVED_ITEM_TYPE"
        [selectOnly]="true"
        (itemSelectionHandler)="openMetricSet($event)">
</ycn-open-item-modal>
